import classnames from "classnames"
import sparkleIcon from "images/icons/icon-sparkle-white.svg?raw"

import SwitchField from "shared/components/switch_field"
import HintPill from "./hint_pill"
import { useBgColorContext } from "./context"

import styles from "./smart_fill_settings.module.scss"

export const PROMPT_REQUIRED = "Add a prompt so Smart Fill knows what to write."

interface Props {
  enabled: boolean
  prompt: string
  onAnotherAction: boolean
  promptError?: string
  onEnabledChange: (enabled: boolean) => void
  onPromptChange: (prompt: string) => void
}

export default function SmartFillSettings({
  enabled,
  prompt,
  onAnotherAction,
  promptError,
  onEnabledChange,
  onPromptChange,
}: Props) {
  const bgColor = useBgColorContext()

  return (
    <section className={styles["smart-fill"]}>
      <div className={styles.header}>
        <div className={styles.text}>
          <p id="smart-fill-label" className={classnames("text-h5", styles.title)}>
            <span className={styles.icon} aria-hidden="true" dangerouslySetInnerHTML={{ __html: sparkleIcon }} />
            Turn on Smart Fill?
          </p>
          <p id="smart-fill-description" className={classnames("body-caption", styles.description)}>
            Each time this Applet runs, Smart Fill will use AI to fill in the fields below based on your prompt.
          </p>
          {onAnotherAction && (
            <p className={classnames("body-caption", styles.description)}>
              Smart Fill is on for another action in this Applet. For now, an Applet can use it on one action.
            </p>
          )}
        </div>
        <SwitchField
          aria-labelledby="smart-fill-label"
          aria-describedby="smart-fill-description"
          checked={enabled}
          disabled={onAnotherAction}
          onColor={bgColor}
          onChange={onEnabledChange}
        />
      </div>

      {enabled && (
        <div className={styles.prompt}>
          <label htmlFor="smart-fill-prompt" className="text-h5">
            Prompt
          </label>
          <textarea
            id="smart-fill-prompt"
            aria-required="true"
            className={styles.textarea}
            rows={4}
            value={prompt}
            placeholder="Describe what you’d like the action to do, and Smart Fill will fill in the fields below to match. For example: “Send me a short summary with the link.”"
            onChange={e => onPromptChange(e.currentTarget.value)}
          />
          {promptError && (
            <HintPill tone="error" variant="on-dark">
              {promptError}
            </HintPill>
          )}
          <p className={classnames("body-caption", styles.helper)}>
            AI reads the trigger and your queries, then fills in the fields below. It can also skip the run if your
            prompt says when.
          </p>
        </div>
      )}
    </section>
  )
}
